"use strict";
class Library {
    constructor(client, data) {
        Object.defineProperty(this, 'client', { value: client });
        this._assignAttributes(data);
        this.downloadUrl = data.links && data.links.download;
    }
    _assignAttributes(data) {
        Object.assign(this, data.attributes);
    }
    download() {
        if (!this.downloadUrl) {
            return Promise.reject(new Error('No download URL for this library'));
        }
        return this.client.downloadFile(this.downloadUrl);
    }
}
module.exports = Library;
//# sourceMappingURL=Library.js.map